
<div class="container-fluid top-space" >
  <div *ngIf="!isReady">
    <p>Loading...</p>
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
</div>
